const cartInitialState = [];

export default cartInitialState;
